import React from 'react';
import { useTranslation } from '../i18n/TranslationContext';

interface ProfileIntroOverlayProps {
  isVisible: boolean;
  onClose: () => void;
  isFirstTime: boolean;
}

export const ProfileIntroOverlay: React.FC<ProfileIntroOverlayProps> = ({ 
  isVisible, 
  onClose, 
  isFirstTime 
}) => {
  const { t } = useTranslation();
  
  if (!isVisible) return null;

  return (
    <div className="profile-intro-overlay">
      {/* Dim background */}
      <div className="overlay-backdrop" onClick={onClose}></div>
      
      {/* Overlay content */}
      <div className="overlay-content">
        <div className="overlay-header">
          <div className="overlay-icon">
            <span className="text-2xl">👤</span>
          </div>
          <h2 className="overlay-title">{t('profile.intro.title')}</h2>
        </div>
        
        <div className="overlay-body">
          <p className="overlay-description">
            {t('profile.intro.description')}
          </p>
          
          <div className="overlay-list">
            <h3>{t('profile.intro.usedFor')}</h3>
            <ul>
              <li>
                <strong>{t('profile.intro.personalIdentification.title')}:</strong> {t('profile.intro.personalIdentification.description')}
              </li>
              <li>
                <strong>{t('profile.intro.communication.title')}:</strong> {t('profile.intro.communication.description')}
              </li>
              <li>
                <strong>{t('profile.intro.languageRequirements.title')}:</strong> {t('profile.intro.languageRequirements.description')}
              </li>
            </ul>
          </div>
          
          <div className="overlay-privacy">
            <p>{t('profile.intro.privacyNote')}</p>
            <p><strong>{t('profile.intro.consentNote')}</strong></p>
          </div>
        </div>
        
        <div className="overlay-footer">
          <button 
            className="overlay-action-button"
            onClick={onClose}
          >
            {t('common.gotIt')}
          </button>
        </div>
      </div>
    </div>
  );
};